import { add, isBefore } from '@sequencehq/utils/dates'
import { CubeReducerState } from 'modules/Cube/domain/cube.domain.types'
import {
  getOriginalScheduleDuration,
  getPhasesDuration
} from 'modules/Cube/domain/postActionStages/queries/getContractDuration'

/**
 * Whether the quote's phases already reach the end of the amended schedule,
 * so any new phase would take the quote past it.
 */
export const getIsAmendedScheduleCovered = (
  prevState: Pick<CubeReducerState, 'data'>
): boolean => {
  const endDates = getAmendedScheduleEndDates(prevState)

  return Boolean(
    endDates && !isBefore(endDates.phasesEndDate, endDates.amendedEndDate)
  )
}

/**
 * Both ends are measured from the quote's start date, the same way
 * `getPhasesDuration` adds the phases up, so filling the gap between them
 * always matches the amended schedule's length.
 */
export const getAmendedScheduleEndDates = (
  prevState: Pick<CubeReducerState, 'data'>
) => {
  if (prevState.data.quote.dealType !== 'AMENDMENT') {
    return
  }

  const originalPhases = prevState.data.quote.amendment?.original.phases ?? []

  if (!originalPhases.length) {
    return
  }

  const originalDuration = getOriginalScheduleDuration(originalPhases)
  const phasesDuration = getPhasesDuration(prevState)

  // An open ended or milestone phase means there's no end to measure from
  if (!originalDuration || !phasesDuration) {
    return
  }

  const startDate = prevState.data.common.startDate ?? new Date()

  return {
    phasesEndDate: add(startDate, phasesDuration),
    amendedEndDate: add(startDate, originalDuration)
  }
}
